import { isHttpError } from '@/http';

/**
 * Returns the `code` field of an HttpError's JSON body (`{ code, message }`),
 * or undefined for network failures, non-HttpErrors and bodies without one.
 */
export function getHttpErrorCode(error: unknown): string | undefined {
	if (!isHttpError(error)) {
		return undefined;
	}
	const data: unknown = error.response?.data;
	if (
		data &&
		typeof data === 'object' &&
		'code' in data &&
		typeof data.code === 'string'
	) {
		return data.code;
	}
	return undefined;
}
